module.exports = __webpack_public_path__ + "static/img/fangAnTop.389fe7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fangAnTop.png
// module id = rBMN
// module chunks = 2